module.exports = __webpack_public_path__ + "static/media/cal_icon.61c8f5a0.png";